import { render, staticRenderFns } from "./TheSnapshotQueryHistoryTable.vue?vue&type=template&id=504ee395&"
import script from "./TheSnapshotQueryHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotQueryHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports